import React from "react";
import "./section2.css";

function Section2() {
  return (
    <div className="Section2">
      <div className="Section2-one">
        <h1>MEET YOUR</h1>
        <h1>NEW JOB</h1>
      </div>
      <div className="Section2-two">
        <p>
          Find the right career for you, based on your experience and interests
        </p>
      </div>
    </div>
  );
}

export default Section2;
